module.exports = __webpack_public_path__ + "img/Standard Army Line of Accounting.f6eb788b.png";